import { useEffect } from "react";
import { NotificationManager } from "../../../notifications/NotificationManager";
import { useApp } from "../../../context/AppContextProvider";
import { useAuth } from "../../../context/UserContextProvider";
import i18n from "../../../language/i18n";
import ErrorLayout from "../../../components/common/error/ErrorLayout";
import {
  forgetDeactivatedProfile,
  formatDeactivatedProfileContext,
  readDeactivatedProfileContext,
} from "../../../utilization/DeactivatedProfileUtilization";

/**
 * Pasif öğrenci: the school has not opened the platform for this learner. The server refuses every token for the
 * profile, so there is nothing behind this screen — the only way out is to log out (or, with another active
 * profile, to log in again and pick that one).
 */
const ProfileInactiveErrorScreen = () => {
  const { setBoarding, isFullScreen, setIsFullScreen } = useApp();
  const { handleStateLogout } = useAuth();
  const contextLine = formatDeactivatedProfileContext(readDeactivatedProfileContext());

  useEffect(() => {
    if (isFullScreen === false) {
      setIsFullScreen(true);
    }
  }, []);

  const handleLogout = () => {
    forgetDeactivatedProfile();
    handleStateLogout();
    // This screen renders outside <Router>, so the URL may still be /login/with-k12 or /login/with-sebit: LANDING
    // would remount that SSO screen, which starts the provider login again (K12: a live provider session hands
    // back a fresh code, the backend refuses it, and the learner lands here again — the only button loops).
    window.history.replaceState({}, "", "/");
    setBoarding("LANDING");
    NotificationManager.success(i18n.t("logout_successful_text"));
  };

  return (
    <ErrorLayout
      statusText={i18n.t("profile_inactive_status_text")}
      helpText={
        contextLine
          ? `${contextLine} — ${i18n.t("profile_inactive_help_text")}`
          : i18n.t("profile_inactive_help_text")
      }
      tone="warning"
      icon="lock"
      actionTitle={i18n.t("logout")}
      onAction={handleLogout}
    />
  );
};

export default ProfileInactiveErrorScreen;
